export const getGlobals = _ => {
  return {
    ...window.GLOBALS,
    $: window.$,
  }
}
